import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Boton = styled.h4`
	margin-top: 1em;
	cursor: pointer;
	z-index: 12;
	color: ${colors.white};
	font-family: 'D-Din', sans-serif;
`;

const NextButton = props => (
	<div style={{ width: '100px', position: 'fixed', bottom: 0, right: 0, padding: '1em', zIndex: 1000  }}>
		<Boton>{props.contenido}</Boton>
	</div>
);

export default NextButton;



// WEBPACK FOOTER //
// ./src/components/NextButton.js